import {NgbDatepicker, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {NgbDatepickerKeyMapService} from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-keymap-service';
import {NgbDatepickerService} from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-service';
import {Component} from '@angular/core';
@Component({
  selector: 'custom-datepicker',
  templateUrl: './custom-datepicker.component.html',
  styleUrls: ['./custom-datepicker.component.scss'],
  providers: [NgbDatepickerService, NgbDatepickerKeyMapService]
})
export class CustomDatePickerComponent extends NgbDatepicker {
}




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/custom-datepicker/custom-datepicker.component.ts